import { render } from "./CookiesBar.vue?vue&type=template&id=ca76c666&scoped=true&ts=true"
import script from "./CookiesBar.vue?vue&type=script&lang=ts"
export * from "./CookiesBar.vue?vue&type=script&lang=ts"

import "./CookiesBar.vue?vue&type=style&index=0&id=ca76c666&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca76c666"]])

export default __exports__